<template>
  <div>
    <page-header :breadcrumRoutes="routes" title="Formulario de baja masiva" />

    <a-form
      name="form"
      layout="vertical"
      ref="formRef"
      :model="formState"
      :rules="rules"
      @finish="onSubmit"
    >
      <a-card class="mb-2">
        <a-row>
          <a-col>
            <a-typography-title class="text-gray-8" :level="4">
              Datos corporativos
            </a-typography-title>
          </a-col>
        </a-row>
        <a-col class="mb-4">
          <a-typography-text class="mb-10">
            Estos datos aparecerán en el campo de texto del email para la
            compañía aseguradora
          </a-typography-text>
        </a-col>
        <a-row :gutter="16" type="flex">
          <a-col :xs="24" :md="12">
            <a-form-item label="Empresa" name="company" has-feedback>
              <select-ordered
                placeholder="Selecciona una empresa"
                v-model="formState.company"
                :options="dataCompany"
                @change="loadInsurance"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="12">
            <a-form-item label="Aseguradora" has-feedback name="insurance">
              <select-ordered
                placeholder="Selecciona una aseguradora"
                v-model="formState.insurance"
                :options="dataInsurance"
                :disabled="blockInsurance"
                @change="loadPolicy"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="8">
            <a-form-item label="Pólizas" has-feedback name="policyId">
              <a-select
                placeholder="Selecciona una póliza"
                v-model:value="formState.policyId"
                :disabled="blockPolicy"
                :options="dataPolicy"
                mode="multiple"
              ></a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
      <a-row :gutter="[16, 8]" type="flex" class="mt-2">
        <a-col v-if="formState.typeForm === '1'" :xs="24" :md="14">
          <a-card style="min-height: 340px">
            <a-typography-title class="text-gray-8" :level="4">
              Mensaje a compañía aseguradora
            </a-typography-title>
            <a-row class="mb-2" :gutter="[16, 16]">
              <a-col :xs="24" :md="16">
                <a-form-item
                  has-feedback
                  label="Escribe un mensaje para la compañía aseguradora"
                  name="message"
                >
                  <a-textarea
                    v-model:value="formState.message"
                    placeholder="Escribe aquí..."
                    :rows="6"
                  />
                </a-form-item>
              </a-col>
              <a-col :xs="24" :md="8">
                <a-form-item name="optionalFiles" label="Archivos opcionales">
                  <a-upload
                    :file-list="formState.optionalFiles"
                    :multiple="true"
                    :remove="handleRemoveOptional"
                    :before-upload="beforeUploadOptional"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                  >
                    <a-button>
                      <upload-outlined />
                      Subir Archivo
                    </a-button>
                  </a-upload>
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
        <a-col :xs="24" :md="10">
          <a-card style="min-height: 340px">
            <a-typography-title class="text-gray-8" :level="4">
              Subir archivo
            </a-typography-title>
            <a
              v-if="formState.insurance"
              :href="documentURL"
              target="_blank"
              rel="noreferrer noopener"
            >
              Descargar formato
            </a>
            <a-form-item
              label="Adjunta documento excel con listado de asegurados"
              has-feedback
              name="fileList"
            >
              <a-row align="middle" class="mt-2 mb-4">
                <a-upload-dragger
                  style="max-width: 100%"
                  v-model:fileList="formState.fileList"
                  name="fileList"
                  :remove="handleRemove"
                  :before-upload="beforeUpload"
                >
                  <p class="ant-upload-drag-icon">
                    <upload-outlined />
                  </p>

                  <div class="ant-upload-text fs-6 text-gray-9">
                    Haz click o arrastra aquí el archivo para cargarlo
                  </div>
                </a-upload-dragger>
              </a-row>
            </a-form-item>
          </a-card>
        </a-col>
      </a-row>

      <a-form-item class="mt-2">
        <a-row type="flex" class="justify-content-end">
          <a-col>
            <a-button
              size="large"
              class="px-4"
              type="primary"
              @click="formSubmit"
              block
            >
              Siguiente
            </a-button>
          </a-col>
        </a-row>
      </a-form-item>
    </a-form>

    <a-modal
      :wrapClassName="'modal-xs'"
      v-model:visible="visible"
      title="Resumen baja masiva"
      :closable="!loading"
      :maskClosable="false"
    >
      <template #footer>
        <a-row type="flex" justify="end">
          <a-col>
            <a-space>
              <a-button @click="visible = false" :disabled="loading">
                Cancelar
              </a-button>
              <a-button
                class="bg-blue-6"
                key="submit"
                type="primary"
                @click="onSubmit"
                :loading="loading"
              >
                Enviar
              </a-button>
            </a-space>
          </a-col>
        </a-row>
      </template>
      <a-typography-title class="text-gray-8" :level="4">
        Datos corporativos
      </a-typography-title>
      <a-typography-text>
        Revisa que los datos ingresados estén correctos.
      </a-typography-text>

      <a-descriptions class="mb-4 mt-2" bordered>
        <a-descriptions-item label="Empresa" :span="3">
          {{
            dataCompany
              .map((e) => e)
              .filter((f) => f.value == formState.company)
              .map((e) => e.label)[0]
          }}
        </a-descriptions-item>
        <a-descriptions-item label="Aseguradora" :span="3">
          {{
            dataInsurance
              .map((e) => e)
              .filter((f) => f.value == formState.insurance)
              .map((e) => e.label)[0]
          }}
        </a-descriptions-item>
        <a-descriptions-item label="Pólizas" :span="3">
          {{
            formState.company >= 1
              ? dataPolicy
                  .filter((e) => {
                    return formState.policyId.find((f) => f == e.value);
                  })
                  .map((e) => e.label)
                  .join(', ')
              : ''
          }}
        </a-descriptions-item>
        <a-descriptions-item label="Documento adjunto" :span="3">
          <a href="">{{ nameFile }}</a>
        </a-descriptions-item>
      </a-descriptions>
      <a-typography-title class="text-gray-8" :level="4">
        Mensaje a compañía aseguradora
      </a-typography-title>
      <a-collapse>
        <a-collapse-panel key="1" header="Desplegar">
          <p
            v-html="
              formState.message
                ? formState.message.replace(/(\r\n|\n|\r)/gm, '<br>')
                : 'No hay mensaje'
            "
          ></p>
        </a-collapse-panel>
      </a-collapse>
    </a-modal>

    <template v-if="showError">
      <a-modal
        v-model:visible="showError"
        centered
        footer=""
        :maskClosable="false"
      >
        <a-result status="error" title="Error" :sub-title="error_text">
          <template #extra>
            <a-button type="primary" @click="handleOk">Cerrar</a-button>
          </template>
        </a-result>
      </a-modal>
    </template>

    <template v-if="showSucess">
      <a-modal
        :wrapClassName="'modal-xs'"
        v-model:visible="showSucess"
        centered
        footer=""
        :maskClosable="false"
      >
        <a-result
          status="success"
          title="Ticket creado"
          sub-title="Tu ticket de baja masiva ha sido creado con éxito."
        >
          <template #extra>
            <router-link
              class="justify-content-center d-flex"
              :to="{
                name: 'BajaMasivaDetail',
                params: { id: createdTicketId }
              }"
            >
              <a-button key="console" type="primary">Ver ticket</a-button>
            </router-link>
          </template>
        </a-result>
      </a-modal>
    </template>
  </div>
  <a-modal
    :wrapClassName="'modal-xs'"
    v-model:visible="showReport"
    @cancel="onCloseReport"
    centered
    :maskClosable="false"
  >
    <template #title>
      <div style="display: flex; align-items: center; gap: 8px">
        <warning-outlined style="font-size: 24px; color: #ff4d4f" />
        <a-typography-text strong style="color: #475569">
          Problemas en el movimiento
        </a-typography-text>
      </div>
    </template>

    <a-row :gutter="12">
      <a-col :span="24">
        <a-typography-paragraph class="mb-3">
          Se detectaron problemas durante el movimiento.
          <br />
          Puedes
          <a-typography-text strong>descargar un reporte</a-typography-text>
          con el detalle de cada registro en la columna
          <a-typography-text strong>'OBSERVACION'</a-typography-text>
          .
        </a-typography-paragraph>

        <a-typography-paragraph class="mb-3">
          <a-typography-text strong>Importante:</a-typography-text>
          <br />
          Este movimiento se intentó realizar
          <a-typography-text strong>hacia la Compañía,</a-typography-text>
          al fallar:
        </a-typography-paragraph>

        <ul class="ml-3 p-0">
          <li>
            <a-typography-text strong type="primary">
              No se envió
            </a-typography-text>
            ningún correo electrónico.
          </li>
          <li>
            <a-typography-text strong type="primary">
              No se creó
            </a-typography-text>
            ningún subticket.
          </li>
        </ul>

        <a-typography-text type="secondary" style="display: block" class="mt-4">
          Este ticket quedará como
          <a-typography-text strong type="danger">FALLIDO</a-typography-text>
          en el listado de tickets masivos.
        </a-typography-text>
      </a-col>
    </a-row>

    <template #footer>
      <router-link
        class="ml-2 mr-2"
        :to="{
          name: 'Bajas',
          hash: '#massive'
        }"
      >
        <a-button type="default">Ver listado de tickets</a-button>
      </router-link>
      <a-button
        v-if="!loadingReport"
        type="primary"
        @click="downloadReport"
        :loading="loadingReport"
      >
        Descargar reporte
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { reactive, ref, watchEffect } from 'vue';
import { getMovementProcessedFile } from '@/network';
import { useStore } from 'vuex';
import { message } from 'ant-design-vue';
import { UploadOutlined, WarningOutlined } from '@ant-design/icons-vue';
import PageHeader from '@/components/page-header.vue';
import SelectOrdered from '@/bewell-components/form-controls/select-ordered.vue';
import {
  FETCH_ALL_COMPANIES,
  FETCH_AM_INSURANCES,
  FETCH_POLICY_INSURANCE_COMPANY,
  GET_LOGGED_USER,
  POST_TICKET_MASSIVE_EXCLUSION,
  FETCH_BM_URL
} from '@/store/types';
import openNotificationWithIcon from '@/utils/notifications';
import delay from '@/utils/delay';

const routes = [
  {
    path: '/bajas',
    breadcrumbName: 'Bajas'
  },
  {
    breadcrumbName: 'Masiva'
  }
];

export default {
  name: 'BajaMasiva',
  components: {
    'page-header': PageHeader,
    'upload-outlined': UploadOutlined,
    'warning-outlined': WarningOutlined,
    'select-ordered': SelectOrdered
  },
  setup() {
    const formRef = ref();
    const store = useStore();
    const blockInsurance = ref(true);
    const blockPolicy = ref(true);
    const dataPolicy = ref([]);
    const dataInsurance = ref([]);
    const dataCompany = ref([]);
    const nameFile = ref('');
    const loading = ref(false);
    const showSucess = ref(false);
    const formState = reactive({
      typeForm: '1',
      brokerId: store.getters[GET_LOGGED_USER].id,
      policyId: [],
      company: null,
      insurance: null,
      documents: [],
      message:
        'A través del presente correo solicitamos la siguiente baja masiva para los rut de colaboradores en el documento adjunto.',
      fileList: [],
      optionalFiles: []
    });
    watchEffect(async () => {
      if (!formState.company || !formState.insurance) return;
      const response = await store.dispatch(FETCH_BM_URL, {
        companyId: formState.company,
        insuranceCompanyId: formState.insurance
      });
      documentURL.value = response;
    });
    const documentURL = ref(null);

    const createdTicketId = ref(null);

    /* modal */
    const visible = ref(false);
    const showError = ref(false);
    const activeKey = ref(['1']);

    watchEffect(async () => {
      await store
        .dispatch(FETCH_ALL_COMPANIES)
        .then((response) => {
          dataCompany.value = response.data.map((a) => {
            return {
              value: a.id,
              label: a.businessName
            };
          });
          if (dataInsurance.value > 0) {
            blockInsuranceSelect();
          }
        })
        .catch((err) => {
          blockInsurance.value = true;
          console.log(err);
          message.error('Compañía no existe');
        });
    });
    const loadInsurance = async () => {
      try {
        formState.policyId = null;
        formState.insurance = null;
        formState.fileList = [];
        blockInsurance.value = true;
        if (formState.insurance == null) {
          blockPolicy.value = true;
          formRef.value.resetFields(['insurance', 'policyId']);
        }
        const response = await store.dispatch(
          FETCH_AM_INSURANCES,
          formState.company
        );
        dataInsurance.value = response.data.map((a) => {
          return {
            value: a.id,
            label: a.businessName
          };
        });
        blockInsurance.value = false;
      } catch (error) {
        console.log(error);
      }
    };
    const loadPolicy = async () => {
      try {
        if (dataPolicy.value.length > 0) {
          dataPolicy.value.splice(0);
        }
        if (formState.policyId) {
          formRef.value.resetFields('policyId');
          formState.policyId = [];
        }
        const response = await store.dispatch(FETCH_POLICY_INSURANCE_COMPANY, {
          company: formState.company,
          insurance: formState.insurance
        });
        if (response.data) {
          dataPolicy.value = response.data.map((a) => {
            return {
              value: a.id,
              label: `${a.numberPolicy}`,
              numberPolicy: a.numberPolicy
            };
          });
          blockPolicy.value = false;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const blockInsuranceSelect = () => {
      formState.insurance = '';
      dataInsurance.value.length = 0;
      blockInsurance.value = true;
    };

    const handleRemove = () => {
      formState.fileList = [];
      formRef.value.validate('fileList');
    };

    const handleRemoveOptional = (file) => {
      const index = formState.optionalFiles.indexOf(file);
      const newFileList = formState.optionalFiles.slice();
      newFileList.splice(index, 1);
      formState.optionalFiles = newFileList;
    };

    const beforeUploadOptional = (file) => {
      const MAX_FILES = 5;
      const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;

      if (formState.optionalFiles.length >= MAX_FILES) {
        message.error('Solo puedes subir un máximo de 5 archivos');
        return false;
      }
      if (file.size > MAX_FILE_SIZE_BYTES) {
        message.error('El archivo debe ser menor a 5MB');
        return false;
      }

      formState.optionalFiles = [...formState.optionalFiles, file];
      return false;
    };

    // Validations
    const checkCompany = async (rule, value) => {
      if (!value) {
        const error_message = 'Seleccione una empresa';
        return Promise.reject(error_message);
      }
      return Promise.resolve();
    };
    const checkInsurance = async (rule, value) => {
      if (!value) {
        const error_message = 'Seleccione una aseguradora';
        return Promise.reject(error_message);
      }
      return Promise.resolve();
    };

    const rules = {
      company: [
        {
          required: true,
          validator: checkCompany,
          trigger: 'change',
          type: 'number'
        }
      ],
      insurance: [
        {
          required: true,
          validator: checkInsurance,
          trigger: 'change'
        }
      ],
      policy: [
        {
          type: 'array',
          required: true,
          message: 'Seleccione una póliza',
          trigger: 'change'
        }
      ],
      message: [
        {
          required: true,
          message: 'Ingrese un mensaje',
          trigger: 'change',
          type: 'string'
        }
      ],
      fileList: [
        {
          type: 'array',
          required: true,
          message: 'Adjunte un archivo',
          trigger: 'change'
        }
      ]
    };

    const reportId = ref(null);
    const showReport = ref(false);
    const loadingReport = ref(false);

    const closeReportModal = () => {
      showReport.value = false;
    };
    const onCloseReport = () => {
      showReport.value = false;
    };

    const downloadReport = () => {
      loadingReport.value = true;
      try {
        const url = getMovementProcessedFile(reportId.value);
        const reportLink = document.createElement('a');
        reportLink.href = url;
        reportLink.download = 'reporte.xlsx';
        reportLink.click();
      } catch (e) {
        console.error('Error al formar la URL o descargar:', e);
      } finally {
        loadingReport.value = false;
      }
    };

    const showModal = () => {
      visible.value = true;
    };

    const formSubmit = () => {
      formRef.value.validate().then(() => {
        visible.value = true;
      });
    };

    const onSubmit = async () => {
      loading.value = true;
      try {
        const res = await store.dispatch(
          POST_TICKET_MASSIVE_EXCLUSION,
          formState
        );
        await delay(1000);
        console.log('La respuesta es: ', res);
        if (res.status === 'success') {
          createdTicketId.value = res.ticketId;
          await delay(1000);
          openNotificationWithIcon(
            'success',
            'Correcto',
            'Ticket de baja masiva creado con éxito.'
          );
          showSucess.value = true;
          formRef.value.resetFields();
        } else if (res.status === 'error') {
          reportId.value = res.processedFileId;
          showReport.value = true;
        }
        blockInsurance.value = true;
        blockPolicy.value = true;
        formState.policyId = null;
        visible.value = false;
        formRef.value.resetFields();
      } catch (error) {
        loading.value = false;
        openNotificationWithIcon(
          'error',
          'Error',
          `Error al generar el ticket de baja masiva. ${
            error.response?.data?.message ||
            'No se pudo procesar la solicitud. Por favor, intenta nuevamente.'
          }`
        );
      }
      loading.value = false;
      visible.value = false;
    };

    const beforeUpload = (file) => {
      nameFile.value = file.name;
      const fileSize = file.size / 1024 / 1024;
      if (fileSize > 5) {
        message.error('El archivo excede el peso máximo 5MB');
      } else {
        formState.fileList[0] = file;
      }
      return false;
    };

    const valueTextArea = ref('');

    return {
      documentURL,
      createdTicketId,
      showSucess,
      loading,
      nameFile,
      onSubmit,
      formRef,
      loadInsurance,
      beforeUpload,
      handleRemove,
      loadPolicy,
      blockInsuranceSelect,
      activeKey,
      dataInsurance,
      dataPolicy,
      blockInsurance,
      blockPolicy,
      dataCompany,
      formState,
      formSubmit,
      showError,
      rules,
      showModal,
      routes,
      value1: ref(),
      valueTextArea,
      visible,
      handleRemoveOptional,
      beforeUploadOptional,
      closeReportModal,
      downloadReport,
      onCloseReport,
      loadingReport,
      showReport
    };
  }
};
</script>
